import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate,currencyFormat } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';

const PendingTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const cellPrice = (data) => {
      if(data!=null || data !=0 ||data !=undefined)
        return <div>$ {data}</div>;
        <div>$ 0.00</div>;
      };
    
      const columns = [ 
        
        {
            dataField: "options",
            text: "Options",
            sort: false,
            width: 100,
            show: true,
            inputType: "text",
            hideColFilter:true,
            action: true
          },  
          {
            dataField: "poDate",
            text: "PO Date",
            sort: false,
            width: 140,
            show: true,
            inputType: "date",
            hideColFilter:true,
            cellRenderer: (rowData) => dateFormate(rowData.poDate),
          },
        {
          dataField: "wholesalerAccount",
          text: "Account #",
          sort: false,
          width: 140,
          show: true,
          inputType: "text",
          hideColFilter:true,
          cellRenderer: (rowData) => cellRendererCheck(rowData.wholesalerAccount),
        },
        {
          dataField: "wholesaler",
          text: "Vendor/Wholesaler",
          sort: false,
          width: 160,
          show: true,
          inputType: "text",
          hideColFilter:true,
          cellRenderer: (rowData) => cellRendererCheck(rowData.wholesaler),
        },
        {
          dataField: "poid",
          text: "PO #",
          sort: false,
          width: 140,
          show: true,
          inputType: "number",
          hideColFilter:true,
          cellRenderer: (rowData) => cellRendererCheck(rowData.poid),
        },
        {
            dataField: "sourcePO",
            text: "Source PO #",
            sort: false,
            width: 140,
            show: true,
            inputType: "number",
            hideColFilter:true,
            cellRenderer: (rowData) => cellRendererCheck(rowData.sourcePO),
          },
        // {
        //   dataField: "itemInvoiceNumber",
        //   text: "Invoice #",
        //   sort: false,
        //   width: 140,
        //   show: true,
        //   inputType: "number",
        //   hideColFilter:true,
        //   cellRenderer: (rowData) => cellRendererCheck(rowData.itemInvoiceNumber),
        // },
        {
          dataField: "packageOrdered",
          text: "Ordered Packages",
          sort: true,
          width: 140,
          show: true,
          inputType: "number",
          cellRenderer: (rowData) => cellRendererCheck(rowData.packageOrdered),
        },
        {
            dataField: "packageAcknowledged",
            text: "Acknowledged Packages",
            sort: true,
            width: 140,
            show: true,
            inputType: "number",
            cellRenderer: (rowData) => cellRendererCheck(rowData.packageAcknowledged),
          },
        {
          dataField: "orderedPackagePrice",
          text: "Ordered Package Price",
          sort: true,
          width: 140,
          show: true,
          inputType: "number",
          cellRenderer: (rowData) => currencyFormat(rowData.orderedPackagePrice),
        },
        {
          dataField: "orderedTotalPrice",
          text: "Ordered Total Price",
          sort: false,
          width: 140,
          show: true,
          hideColFilter:true,
          inputType: "number",
          cellRenderer: (rowData) => currencyFormat(rowData.orderedTotalPrice),
        },{
            dataField: "acknowledgedPackagePrice",
            text: "Acknowledged Package Price",
            sort: false,
            width: 140,
            show: true,
            inputType: "number",
            hideColFilter:true,
            cellRenderer: (rowData) => currencyFormat(rowData.acknowledgedPackagePrice),
          },
          {
            dataField: "acknowledgedTotalPrice",
            text: "Acknowledged Total Price",
            sort: false,
            width: 140,
            show: true,
            hideColFilter:true,
            inputType: "number",
            cellRenderer: (rowData) => currencyFormat(rowData.acknowledgedTotalPrice),
          }
      ];

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='inventory-table'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            hasScrollArrow={false}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            hasPagination
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            filters={colFilter}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default PendingTable;
